<template>
  <div class="modal inset-0">
    <div class="container modal-container">
      <button @click="closeModal" class="modal-close">
        <i class="fas fa-times text-2xl"></i>
      </button>
      <div class="grid grid-cols-1 md:grid-cols-2 min-h-100vh">
        <section>
          <base-section-title>#Gallery'</base-section-title>
          <div class="mt-5 mx-5 text-center">
            <carousel style="height: 79vh;" class="cursor-pointer" :paginationColor="'rgb(144, 144, 144)'" :minSwipeDistance="150" :perPage="1" :navigationEnabled="true" v-if="project.attachments.length > 0">
              <slide style="overflow: hidden; height: 77vh;" :key="`attachment_${index}`"
                     v-for="(attachment, index) in project.attachments">
                <youtube v-if="attachment.mime_type === 'video/youtube'" :video-id="getIdFromURL(attachment.location)"
                         class="video-player"
                         player-width="100%"
                         player-heigth="100%"
                         host="https://www.youtube.com"></youtube>
                <img v-else
                  style="object-fit:contain; width: 100%; height: 100%; padding-bottom: 50px;"
                  :src="attachment.location" @mouseup="openImageModal(attachment.location, $event)"
                  @mousedown="openImageModal(attachment.location, $event)"/>
              </slide>
            </carousel>
            <span class="font-bold text-2xl" v-else>
              {{ $t('projects.no-attachment') }}
            </span>
          </div>
        </section>
        <section class="project-modal-details mt-5 md:mt-0">
          <base-section-title>#Details'</base-section-title>
          <p><span class="project-modal-details-prop">name</span> : {{ project.name }}</p>
          <p><span class="project-modal-details-prop">description</span></p>
          <article class="project-modal-details-description" v-html="project.description"></article>
          <p>
            <span v-for="(tech, index) in project.technologies" :key="'tech'+index" class="technology">
              <i v-if="tech.icon_type==='fa'" :class="tech.icon"></i>
              {{tech.name}}
            </span>
          </p>
        </section>
      </div>
    </div>
    <transition name="slide-up">
      <base-zoom-image @onCloseModal="closeImageModal" :is-fullscreen="true" :order="2" :image="selectedImage" v-if="showImageModal" />
    </transition>
  </div>
</template>

<script>
import BaseSectionTitle from '../BaseSectionTitle'
import { Carousel, Slide } from 'vue-carousel'
import ModalMixin from '../../../mixins/modal-mixins'
import BaseZoomImage from './BaseZoomImage'
import { getIdFromURL } from 'vue-youtube-embed'

export default {
  name: 'BaseProjectModal',
  mixins: [ModalMixin],
  components: { BaseZoomImage, BaseSectionTitle, Carousel, Slide },
  data () {
    return {
      showImageModal: false
    }
  },
  props: {
    project: { type: Object }
  },
  created () {
    this.imageClickPos = {}
    this.selectedImage = null
  },
  methods: {
    getIdFromURL,
    openImageModal (image, event) {
      if (event.type === 'mousedown') {
        const { clientX, clientY } = event
        this.imageClickPos = { clientX, clientY }
      } else if (event.type === 'mouseup') {
        if (this.imageClickPos.clientX === event.clientX && this.imageClickPos.clientY === event.clientY) {
          this.showImageModal = true
          this.selectedImage = image
        }
      }
    },
    closeImageModal () {
      this.showImageModal = false
      this.selectedImage = null
    }
  }
}
</script>

<style scoped>
.project-modal-details > p {
  @apply mt-5;
}
.project-modal-details-description{
  @apply mt-1 ml-2 list-inside list-disc;
}

.project-modal-details-prop {
  font-family: '8bit', sans-serif;
}

.project-modal-details-description >>> ul {
  @apply list-inside list-disc ml-5;
}
.technology {
  @apply inline-block m-1 px-2 py-1 rounded-full border border-black;
}
</style>
